import SelectBox from "devextreme-react/select-box";
import React from "react";

const boolEditorItems = [
  { text: "Yes", value: true },
  { text: "No", value: false },
];

const onFocusIn = (e) => {
  console.log("onFocusIn", e);
  e.component.open();
};

export const boolEditorRender = (cell) => {
  const onValueChanged = (e) => {
    cell.setValue(e.value);
  };

  return (
    <SelectBox
      defaultValue={cell.value}
      displayExpr="text"
      valueExpr="value"
      onValueChanged={onValueChanged}
      onFocusIn={onFocusIn}
      items={boolEditorItems}
    />
  );
};
